<template>
	<div class="row">
		<div class="col-12 col-md-4 offset-md-4 mt-5">
			<ResetPassword/>
		</div>
	</div>
</template>

<script>
import ResetPassword from '../Widgets/ResetPassword/ResetPassword.vue';

export default {
  name: 'ResetearContrasena',
  components: {
    ResetPassword,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
